import { render, staticRenderFns } from "./VersionManagement.vue?vue&type=template&id=5a32f29a&scoped=true&"
import script from "./VersionManagement.vue?vue&type=script&lang=js&"
export * from "./VersionManagement.vue?vue&type=script&lang=js&"
import style0 from "./VersionManagement.vue?vue&type=style&index=0&id=5a32f29a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a32f29a",
  null
  
)

export default component.exports